<!--

 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="layout" ref="layout" :style="{ 'overflow-x': 'auto', 'background-color': bgColor, }"  :class="dashboard.style === 'dark'?'workbench-dark':''">
    <a-spin size="large" :spinning="viewLoading">
      <div class="export-btn">
        <div class="top-left">
          <icon-font type="icon-left" style="margin-right: 12px" @click="goBack" v-if="backUrl"/>
          <img :src="dashboard.style === 'dark'?logoDark:logo" width="160" alt @click="turnToHome" style="cursor: pointer"/>
          <span v-if="name" class="model-name">&nbsp;-&nbsp;{{name}}</span>
        </div>
        <a-button @click="exportDashboard()"  type="primary" ghost> 
          <icon-font class="title-icon" type="icon-Export"  />
            导出
        </a-button>
      </div>
      <div :style="bigScreenStyle" ref="container" style="position: relative;">
        <widget
          v-for="(widget, index) in widgets"
          :key="index"
          :index="index"
          v-model="widget.value"
          :type="widget.type"
          @timeChange="dataChange"
          :dashboard="dashboard"
          :name="name"
          :widget="widget"
          ref="widget"
          :searchCondition="searchCondition"
        />
      </div>
    </a-spin> 
  </div>
</template>

<script>
import widget from "../designer/widget/temp";
import { getAnalysisTemplatesDetails, getWidgetsData, getBaseWidgetsData, shareTemplateExport } from '@/api/template'
import {  previewInternal, getAnalysisTemplatesDetailsInternal } from "@/api/shareModal"
import { mapGetters } from 'vuex';
import moment from "moment"
import html2canvas from 'html2canvas'

export default {
  name: "NoPermissionView",
  components: {
    widget
  },
  data() {
    return {
      bigScreenStyle: {},
      widgets: [],
      bgColor: '',
      dashboard: {
        style: 'normal'
      },
      backUrl: '',
      name: '',
      logo: require('@/assets/images/logo.svg'),
      logoDark: require('@/assets/images/logo-dark.svg'),
      reportCode: '',
      filterCondition: [],
      searchCondition: [],
      globalDateRang: {}
    };
  },
  provide() {
    return {
      isbase: () => false,
      getDashboardDynamicData: () => this.dashboard?.dynamicData,
      getIndex: () => 0,
      widgetUpdate: () => {},
      filterSearch: this.filterSearch,
      setFilterCondition: this.setFilterCondition,
      getFilterCondition: () => this.filterCondition,
    };
  },
  async mounted() {
    const reportCode = this.$route.query.reportCode;
    this.backUrl = this.$route.query.backUrl
    this.reportCode = reportCode
    let canvas = {}
    let widgets = []
    if(reportCode) {
      const { code, data } = await getAnalysisTemplatesDetailsInternal(reportCode);
      if (code != 200) return;
      canvas = data.canvas
      widgets = data.canvas.widgets;
      this.name = data.name
      canvas.customOptions = data.customOptions || {}
    } else {
      canvas = localStorage.getItem('viewCanvas')
      if(canvas) {
        canvas = JSON.parse(canvas)
        widgets = canvas.widgets;
        this.name = canvas.name
      }
    }
    this.dashboard.dynamicData = canvas.dynamicData
    this.dashboard.style = canvas.customOptions?.style || 'normal'
    let obj = widgets.find(v => v.type === 'widget-time')
    console.log(obj, '1111')

    let val,value = undefined
    if(obj&&obj.value.setup.timeSelector) {
      val = obj.value.setup.timeSelector
      value = this.$timeSelectorToDate(val)
      value = value.map(v => v.format?v.format('YYYY-MM-DD'):moment(v).format('YYYY-MM-DD'))
      obj.value.setup.value = value
      this.globalDateRang = {
        from: value[0],
        to: value[1],
        timeSelector: val
      }
    }
    widgets.forEach((v ,i) => {
      v.index = i
      if(v.dynamicDataParam&&v.type !== 'widget-table') {
        v.dynamicDataParam.pageSize = 1000
      }
      if(v.dynamicDataParam&&v.type === 'widget-table') {
        v.dynamicDataParam.pageSize = v.value.setup?.pageSize || 10
      }
      // if(canvas.dynamicData&&canvas.dynamicData.contextData?.datasource) {
      //   let context = canvas.dynamicData.contextData
      //   if(v.dynamicDataParam&&!v.dynamicDataParam.datasource) {
      //     v.dynamicDataParam.datasource = context.datasource
      //     v.dynamicDataParam.accountIds = context.accountIds
      //     v.dynamicDataParam.tableId = context.tableId
      //     v.dynamicDataParam.filterType = context.filterType
      //   }
      // }
      if(val&&v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
        v.dynamicDataParam.globalDateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
      // 转独立日期
      let contextData = v.value.data?.dynamicData?.contextData
      if(contextData&&contextData.dateRang&&contextData.dateRang.timeSelector) {
        let val = contextData.dateRang.timeSelector
        let value = this.$timeSelectorToDate(val)
        contextData.dateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
    })
    this.widgets = widgets
    console.log(widgets)
    // text-filter
    let filters = widgets.filter(v => v.type === 'widget-text-filter')
    let filterCondition = []
    try {
      filters.forEach(v => {
        let list = v.value.data.dynamicData
        list.forEach(val => {
          val.value = v.value.data.text
          val.index = v.index
          val.name = val.dimension
          val.relation = 'AND'
        })
        filterCondition = filterCondition.concat(list)
      })
    } catch (error) {
      console.log(error)      
    }
    this.filterCondition = filterCondition
    this.bgColor =  canvas.backgroundColor;
    this.bigScreenStyle = {
      'height': canvas.height + 'px',
      'width': canvas.width + 'px',
      'background-color': canvas.backgroundColor,
      'background-image': canvas.backgroundImage?'url(' + canvas.backgroundImage + ')':'',
      'background-position': '0% 0%',
      'background-size': '100% 100%',
      'background-repeat': 'initial',
      'background-attachment': 'initial',
      'background-origin': 'initial',
      'background-clip': 'initial',
      'margin-left': 'auto',
      'margin-right': 'auto'
    }
    if(!obj) {
      this.getData({})
    }
  },
  computed: {
    ...mapGetters({
        viewLoading: 'viewLoading'
    }),
  },
  methods: {
    setFilterCondition(index, value) {
      this.filterCondition.filter(v => v.index === index).forEach(v => {
        v.value = value
      })
    },
    filterSearch() {
      let widgets = this.$deepclone(this.widgets)
      widgets.forEach((v, i) => {
        if(v.type === 'widget-table'&&v.dynamicDataParam) {
          let wRef = this.$refs.widget[i]?.$refs?.component
          v.dynamicDataParam.orders = wRef?.orders?.length?wRef.orders:v.dynamicDataParam.orders
          v.dynamicDataParam.conditions
 = v.dynamicDataParam?.conditions?.concat(wRef?.filterConditions || [])
        }
      })
      this.getData(widgets)
      try {
        let hasDateRangList = widgets.filter((v, i) => v.dynamicDataParam&&v.dynamicDataParam.dateRang&&v.dynamicDataParam.dateRang.from)
        if(hasDateRangList.length) {
          hasDateRangList.forEach(v => {
            this.$refs.widget[v.index].filterSearch()
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    turnToHome() {
      this.$router.push({
        path: '/'
      })
    },
    goBack() {
      gtag('event', 'model_view_back', {
        backUrl: this.backUrl
      });	
      location.href = this.backUrl
    },
    dataChange(val) {
      this.widgets.forEach(v => {
        if(v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
          v.dynamicDataParam.globalDateRang = val
        }
        if(v.value.data?.dynamicData?.contextData) {
          v.value.data.dynamicData.contextData.globalDateRang = val
        }
      })
      this.globalDateRang = val
      this.getData()
    },
    async getData() {
      console.log(this.widgets)
      let params = this.widgets.filter(v => v.dynamicDataParam)
      if(params.length) {
        this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
        // let query = this.$route.query
        const reportCode = this.$route.query.reportCode;
        // let api = query.isbase?getBaseWidgetsData:getWidgetsData
        previewInternal(reportCode, {
          globalDateRang: this.globalDateRang,
          globalConditions: this.filterCondition || []
        }).then((res) => {
          let data = res.data || {}
          Object.keys(data).forEach(key => {
            this.$nextTick(() => {
              this.$refs.widget[key].init(data[key])
            })
          })
        }).finally(() => this.$store.commit("modelDesign/SET_VIEW_LOADING", false))
      }
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while(n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr, {type: mime}])
    },
    //  导出
    async exportDashboard() {
      if (!this.name) {
        this.$message.error("名称不能为空");
        return;
      }
      let canvasID = this.$refs['container']
      console.log(canvasID)
      let scrollHeight = this.$refs['layout'].scrollHeight - 56
      canvasID.style.height = scrollHeight + "px"
      this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
      const OriginalImage = window.Image
      window.Image = function (...args) {
        const img = new OriginalImage(...args)
        img.crossOrigin = 'anonymous'
        return img
      }
      try {
        const canvas = await html2canvas(canvasID, { useCORS: true, allowTaint: false })
        let dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        document.body.removeChild(dom)
        let blob = this.dataURLToBlob(dom.toDataURL('image/png'))
        URL.revokeObjectURL(blob)
        let widgets = this.$deepclone(this.widgets)
        let globalOptions;
        if (this.dashboard?.dynamicData?.contextData) {
          globalOptions = {
            globalAccountIds: this.dashboard.dynamicData.contextData.accountIds,
            globalDataSource: this.dashboard.dynamicData.contextData.datasource,
            globalFilterType: this.dashboard.dynamicData.contextData.filterType,
            globalTableId: this.dashboard.dynamicData.contextData.tableId,
          }
        }
        if(this.searchCondition.length) {
          if(globalOptions) {
            globalOptions.globalConditions = this.searchCondition
          } else {
            globalOptions = {
              globalConditions: this.searchCondition
            }
          }
        }
        widgets = widgets.map((v, index) => ({
          ...v,
          index
        })).filter(v => v.value?.data?.dataType === "dynamicData").map((v,i) => ({ 
          dynamicDataParam: { 
            ...v.value.data?.dynamicData || {},
            ...v.value.data?.dynamicData?.contextData?v.value.data.dynamicData.contextData:{},
            globalOptions
          },
          type: v.type,
          title: v.value.setup?.titleText || ''
        }))
        widgets.forEach((v) => {
          if(v.type === 'widget-table'&&v.dynamicDataParam) {
            let wRef = this.$refs.widget[v.index]?.$refs?.component
            v.dynamicDataParam.orders = wRef?.orders?.length?wRef.orders:v.dynamicDataParam.orders
            v.dynamicDataParam.conditions
  = v.dynamicDataParam?.conditions?.concat(wRef?.filterConditions || [])
          }
        })
        let index = 1
        widgets.filter(v => v.type === 'widget-table').forEach(v => {
          let title = v.title.replace(/\\|\/|\?|\?|\*|\[|\]|\[|\]|\:/g, '')
          if(!title) {
            title = `表格${index}`
            index++
          }
          v.title = title.slice(0, 31)
        })
        let param = new FormData()       // 创建form对象     
        param.append('file', blob)       // 通过append向form对象添加数据
        param.append("template", JSON.stringify({
          name: this.name,
          widgets
        })); // 添加form表单中其他数据
        const res = await shareTemplateExport(param, this.reportCode)
        if(res.code === 200) {
          this.$message.success('数据导出中，请稍后在【下载中心】查看')
        }
      } catch (error) {
        console.error('导出失败', error)
        this.$message.error('导出失败')
      } finally {
        window.Image = OriginalImage // 一定要还原，避免影响页面其它地方
        this.$store.commit("modelDesign/SET_VIEW_LOADING", false);
      }
    },
  }
};
</script>

<style scoped lang="less">
.layout {
  width: 100%;
  height: 100%;
  text-align: center;
}
.bottom-text {
  width: 100%;
  color: #a0a0a0;
  position: fixed;
  bottom: 16px;
  z-index: 9999;
}
/deep/ .ant-spin-nested-loading > div > .ant-spin{
  max-height: none;
}
.top-left {
  float: left;
  line-height: 32px;
  margin-left: 24px;
  font-size: 16px;
  overflow: hidden;
  .anticon {
    color: #677392;
    cursor: pointer;
  }
  .model-name {
    font-size: 20px;
    color: #22AC35;
  }
}
.export-btn {
  text-align: right;
  margin-right: 24px;
  margin-top: 12px;
  margin-bottom: 12px;
  overflow: hidden;
}
</style>
